import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useStyles } from "./style";
import TreeItems from "./tree";
import LoadingComponent from "../../../../components/loading";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@mui/material/DialogActions";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { getTreeList } from "../../../../store/tree/actions";
import { postMoveDoc } from "../../../../store/explorer/actions";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export function MoveDocPlace(props, prev) {
  const classes = useStyles();
  const [itemTree, setItemTree] = React.useState(null);
  const [tree, setTree] = React.useState(null);
  const [treePrevius, setTreePrevius] = React.useState(null);

  const [showNew, setShowNew] = useState(false);
  const [item, setItem] = useState(false);
  const notify = (msj, event) => toast[event](msj);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { responseTree, errorTree, loading } = useSelector((state) => ({
    responseTree: state.Tree.responseTreeMove,
    errorTree: state.Tree.errorTree,
    loading: state.Tree.loadingTree,
  }));
  const { responseMoveDoc, errorMoveDoc, loading2 } = useSelector((state) => ({
    responseMoveDoc:
      state.Explorer.responseMoveDoc === undefined
        ? "none"
        : state.Explorer.responseMoveDoc,
    errorMoveDoc: state.Explorer.errorMoveDoc,
    loading2: state.Explorer.loadingMoveDoc,
  }));

  useEffect(() => {
    setItem(props.itemMove);
    setItemTree(null); // No default: user must select a folder (Root removed - users without full permissions lose access)
    setTreePrevius(props.treePrevius);
    setTree(props.tree);
    setShowNew(props.show);
  }, [props.show]);

  useEffect(() => {
    if (responseTree) {
      setTree(responseTree);
    }
  }, [responseTree]);

  useEffect(() => {
    if (responseMoveDoc !== "none") {
      props.move(true);
      close();
    }
  }, [responseMoveDoc]);

  const close = () => {
    props.close();
  };

  const selectTree = (item) => {
    setItemTree(item);
    setTree({
      label: item.label,
      value: item.value,
      parent: !tree.label ? "" : item.parent ? item.parent.id : "",
    });

    dispatch(
      getTreeList(
        { parentArchiveId: item.value, direction: "", isMoveAction: true },
        navigate
      )
    );

    let m = JSON.parse(JSON.stringify(treePrevius));
    // let m = treePrevius;
    m.push({
      name: item.label,
      id: item.value,
      parent: !tree.label ? "" : item.parent ? item.parent.id : "",
    });
    setTreePrevius(m);
  };

  const backTree = (item) => {
    let newMap = [];
    let end = treePrevius.length;
    dispatch(
      getTreeList(
        { parentArchiveId: item.value, direction: "UP", isMoveAction: true },
        navigate
      )
    );

    if (!item.value) {
      setTree([]);
    }

    treePrevius.map((map, idx) => {
      if (map.id != treePrevius[end - 1].id) {
        newMap.push(map);
      }
    });
    if (treePrevius.length > 1) {
      /**DOC-1702 if it have at least 1 previous, then it is not root and we set the current item tree */
      setItemTree({
        label: treePrevius[treePrevius.length - 2].name,
        value: treePrevius[treePrevius.length - 2].id,
        parent: "",
      });
    } else {
      // At root level: user navigated here, so Root is a valid choice (not the default)
      setItemTree({ label: "Root", value: "Root", parent: "" });
    }

    setTreePrevius(newMap);
  };

  const moveFile = () => {
    if (!itemTree) {
      notify("Please select a folder to move to", "error");
      return;
    }
    let arc = [];
    arc.push(item.fkArchive.id);
    let obj = {
      archiveOverride: false,
      keep: false,
      archives: arc,
    };
    if (itemTree.value !== "Root") {
      obj.targetArchiveId = itemTree.value;
    }
    dispatch(postMoveDoc(obj, navigate));
  };

  const canMove = !!itemTree;

  return (
    <BootstrapDialog
      onClose={() => {
        close();
      }}
      style={{ overflow: "hidden" }}
      aria-labelledby="customized-dialog-title"
      open={showNew}
    >
      <LoadingComponent show={loading || loading2} text={"Moving Item..."} />
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={() => {
          close();
        }}
      >
        Move document
      </BootstrapDialogTitle>
      <DialogContent style={{ width: "520px", overflow: "hidden" }} dividers>
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 14, color: "#374151", marginBottom: 4 }}>
            Move to:{" "}
            <span style={{ fontWeight: "700", color: itemTree ? "#0076FF" : "#6b7280" }}>
              {itemTree ? itemTree.label : "Select a folder..."}
            </span>
          </div>
          <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>
            {itemTree
              ? "Destination selected. Click MOVE to confirm."
              : "Click a folder in the list below to choose the destination."}
          </div>
        </div>
        <div style={{ backgroundColor: "#f8fafc", borderRadius: 8, padding: 12, marginTop: 8, minHeight: 120 }}>
          <TreeItems
            click={selectTree.bind(this)}
            backTree={backTree.bind(this)}
            treePrevius={treePrevius}
            tree={tree}
            hideTrash={true}
            key="move-explorer"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={close.bind(this)}
          className={classes.buttonModelCancel}
        >
          CANCEL
        </Button>
        <Button
          variant="outlined"
          onClick={moveFile.bind(this)}
          className={`${classes.buttonModelOk} ${!canMove ? classes.buttonModelOkDisabled : ""}`}
          disabled={!canMove}
        >
          MOVE
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}

export default MoveDocPlace;
